import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import Select, { SelectOptions } from '../../elements/formElements/Select';
import handleValidationErrors, { ValidationErrors } from '../../helpers/ResponseErrorHelper';
import useBlockingSubmit from '../../hooks/useBlockingSubmit';

type Props = {
    action: (selectedValue: string) => Promise<unknown>;
    selectElements: SelectOptions;
    field: string;
    title: string;
    setWasAttached?: (value: boolean) => void;
};

function AttachForm({ action, selectElements, field, title, setWasAttached }: Props) {
    const history = useHistory();
    const [value, setValue] = useState('');
    const [errors, setErrors] = useState<ValidationErrors>({});
    const [Submit, submitBlocked] = useBlockingSubmit();

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        try {
            await action(value);
            if (setWasAttached) setWasAttached(true);
            history.goBack();
        } catch (error) {
            handleValidationErrors(error, setErrors);
            submitBlocked(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <Select
                field={field}
                value={value}
                label={title}
                options={selectElements}
                error={errors[field]?.[0]}
                handleChange={(event) => setValue(event.target.value)}
            />
            <button type="button" onClick={() => history.goBack()} className="btn btn-secondary">
                Cancel
            </button>
            <Submit label="Attach" />
        </form>
    );
}

export default AttachForm;
